import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-bottom: 24px;
`
